import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import Gallery from "../components/Gallery";
import YouTubeEmbed from "../components/YouTubeEmbed";
import CtaBand from "../components/CtaBand";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { countertopsPage, seo } from "../data/siteData";

export default function Countertops() {
  useSeo(seo["/countertops"].title, seo["/countertops"].description);
  useReveal();
  return (
    <>
      <PageHero image={countertopsPage.hero} title={countertopsPage.h1} />

      <section className="bg-white py-16">
        <div className="mr-container mr-body reveal">
          <h2 className="mr-h2 text-2xl sm:text-[28px]">{countertopsPage.subhead}</h2>
          <div className="mt-4">
            {countertopsPage.paragraphs.map((p) => (
              <p key={p.slice(0, 30)} className="text-[16.5px]">
                {p}
              </p>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/color-choices"
              className="bg-[#244aa2] px-8 py-3.5 text-[12px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-200 hover:bg-[#0c2a66]"
            >
              View Countertop Color Choices
            </Link>
            <Link
              to="/countertops-faq"
              className="border-2 border-[#244aa2] px-8 py-3.5 text-[12px] font-bold uppercase tracking-[0.1em] text-[#244aa2] transition-colors duration-200 hover:bg-[#244aa2] hover:text-white"
            >
              Countertops FAQ
            </Link>
          </div>

          <div className="mx-auto mt-14 max-w-3xl">
            <YouTubeEmbed id={countertopsPage.video.id} title={countertopsPage.video.title} />
          </div>
        </div>
      </section>

      <Gallery images={countertopsPage.gallery} title="Kitchen Countertop Resurfacing Gallery" />
      <CtaBand headline="Update your kitchen counters in a single day" />
    </>
  );
}
